<div class="card-custom">
  <div class="card-custom__item">
    <h3>
      <span>
        Sind die PV-Module dieser Stromerzeugungseinheit (Technische Ressource) nachgeführt?
        <app-required-asterisk />
      </span>
      <app-tooltip
        text="Nachgeführte PV-Module sind auf beweglichen Montagesystemen installiert, die dem Sonnenstand folgen – entweder einachsig (Ost-West) oder zweiachsig (horizontal und vertikal). Durch die automatische Ausrichtung zur Sonne kann der Energieertrag im Vergleich zu starren Anlagen deutlich erhöht werden. Die Angabe ist wichtig für die realistische Einschätzung des Stromertrags." />
    </h3>
    @for (option of solarTrackedModulesOptions; track option) {
      <div>
        <input
          [id]="`radio-solar-tracked-modules-${option.value}-${resourceId()}`"
          class="bricks-input"
          type="radio"
          [formControl]="resource.controls.solarTrackedModules"
          [value]="option.value"
          [name]="`solarTrackedModules-${resourceId()}`"
          [class.error]="
            resource.controls.solarTrackedModules.hasError('required') && resource.controls.solarTrackedModules.touched
          " />
        <label [for]="`radio-solar-tracked-modules-${option.value}-${resourceId()}`" class="density">
          {{ option.label }}
        </label>
      </div>
    }
  </div>
  <div class="card-custom__item">
    <h3>
      <span>
        Sind die PV-Module dieser Stromerzeugungseinheit (Technische Ressource) bifazial?
        <app-required-asterisk />
      </span>
      <app-tooltip
        text="Bifaziale Solarmodule erzeugen Strom von beiden Seiten – auch mit Licht, das vom Boden reflektiert wird. Das kann den Stromertrag erhöhen." />
    </h3>

    @for (option of solarBifacialOptions; track option) {
      <div>
        <input
          [id]="`radio-solar-bifacial-${option.value}-${resourceId()}`"
          class="bricks-input"
          type="radio"
          [formControl]="resource.controls.solarBifacial"
          [value]="option.value"
          [name]="`solarBifacial-${resourceId()}`"
          [class.error]="
            resource.controls.solarBifacial.hasError('required') && resource.controls.solarBifacial.touched
          " />
        <label [for]="`radio-solar-bifacial-${option.value}-${resourceId()}`" class="density">
          {{ option.label }}
        </label>
      </div>
    }
  </div>
</div>
@if (resource.controls.solarTrackedModules.value === false) {
  @let solarTiltDegree = resource.controls.solarTiltDegree;
  <div class="flex-row">
    <div class="flex-col-50 input-tooltip-row">
      <bricks-input
        [showResetOption]="true"
        appDigitsOnly
        [allowComma]="false"
        [label]="'Neigung der TR (In Grad)'"
        [placeholder]="'z. B. 25'"
        [isRequired]="true"
        [formControl]="solarTiltDegree"
        [width]="'fill'"
        type="number"
        name="solarTiltDegree">
        <span text-suffix>°</span>
        @if (solarTiltDegree.errors) {
          <bricks-error>
            {{ getSolarTiltDegreeError(solarTiltDegree) }}
          </bricks-error>
        }
      </bricks-input>
      <app-tooltip text="Bitte geben Sie die Neigung, die für die überwiegende Anzahl der PV-Module gilt, an." />
    </div>
    <div class="flex-col-50 input-tooltip-row">
      <bricks-input-dropdown
        [showResetOption]="true"
        [label]="'Ausrichtung der TR (Himmelsrichtung)'"
        [placeholder]="'Bitte auswählen'"
        [isRequired]="true"
        [formControl]="resource.controls.solarOrientation"
        [width]="'fill'"
        name="solarOrientation">
        @for (option of solarOrientationOptions; track option) {
          <bricks-option [value]="option.value">
            {{ option.label }}
          </bricks-option>
        }
      </bricks-input-dropdown>
      <app-tooltip
        text="Bitte geben Sie die Himmelsrichtung, in welche die überwiegende Anzahl der PV-Module ausgerichtet sind, an." />
    </div>
  </div>
}
